/* unplugin-vue-components disabled */import { render } from "./default.vue?vue&type=template&id=51d42fc2&scoped=true"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"

import "./default.vue?vue&type=style&index=0&id=51d42fc2&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d42fc2"]])

export default __exports__